export default class Language {

    constructor(id, name, code){
        this.id = id;
        this.name = name;
        this.code = code;
    }

    getId(){
        return this.id;
    }

    getName(){
        return this.name;
    }

    getCode(){
        return this.code;
    }

    setId(id){
        this.id = id;
    }

    setName(name){
        this.name = name;
    }

    setCode(code){
        this.code = code;
    }
}